






































































import Vue from 'vue';
import { mapGetters } from 'vuex';
import pxCard from '@/dex-shared/components/px-card.vue';
import Icon from '@/dex-shared/components/Icon.vue';
import pxTooltip from '@/dex-shared/components/px-tooltip.vue';
import Tags from '@/components/Tags.vue';
import BoardModel from '@/dex-shared/models/BoardModel';

export default Vue.extend({
  components: {
    pxCard,
    pxTooltip,
    Icon,
    Tags,
  },

  props: {
    examGroupId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      tooltipClicked: false,
      tooltipActive: false,
    };
  },

  computed: {
    ...mapGetters({
      examGroupById: 'examGroupById',
      allBoards: 'allBoards',
    }),
    examGroup() {
      return this.examGroupById(this.examGroupId);
    },
    boards() {
      return this.allBoards
        .concat()
        .sort((a: BoardModel, b: BoardModel) => a.title.localeCompare(b.title));
    },
  },

  methods: {
    loadBoards(showBoards: boolean) {
      this.tooltipActive = showBoards;
    },
    toggleBoardSelector() {
      this.tooltipClicked = !this.tooltipClicked;
    },
    addToBoard: async function(boardId: number, examGroupId: number) {
      await this.$store.dispatch('ADD_MATERIAL', { boardId, examGroupId });
      await this.$store.dispatch('PULL_EXAM_GROUPS', this.currentPage);
    },
    removeFromBoard: async function(boardId: number) {
      const material = this.examGroup.getters
        .materialsByExamGroupId(this.examGroupId)
        .find(material => material.boardId === boardId);

      if (
        confirm('Tem certeza que deseja remover esse simulado desse mural?')
      ) {
        await this.$store.dispatch('REMOVE_MATERIAL', material.id);
        this.$store.commit('DELETE_ENTITY', {
          entity: 'materials',
          id: material.id,
        });
      }
    },
    removeExamGroup: async function(examGroupId: number) {
      if (
        confirm(
          'Tem certeza que deseja deletar esse simulado? Ele não poderá ser recuperado!',
        )
      ) {
        const response = await this.$store.dispatch(
          'REMOVE_EXAM_GROUP',
          examGroupId,
        );

        if (response !== true) {
          //TODO analyze the error
          alert('Esse simulado não pode ser deletado!');
        }
      }
    },
  },
});
